import type { FilterSelectItem } from '@jane/search/types';

export const hasFilterableOptions = (options: FilterSelectItem[]) =>
  !!options.find(({ count }) => count > 0);
